"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const token = (creds) => ({
    getUserId: () => {
        const decoded = (0, jwt_decode_1.default)(creds.token ? creds.token : "");
        if (!decoded) {
            return {};
        }
        return { userId: decoded.user_id };
    },
});
exports.default = token;
